/*
   THIS FILE IS AUTOGENERATED, DO NOT MODIFY!!!!!!
   If you need to change this, go to the authz master, change it there then regenerate this.
*/
type Action = { id: string; type: "property" | "global"; enablingScopes: string[] };

const GetPropertyTickers: Action = {
  id: "GetPropertyTickers",
  type: "global",
  enablingScopes: [
    "backoffice_access",
    "property:read",
    "property:superadmin",
    "system_superadmin",
  ],
};
const ChangeOwnPassword: Action = {
  id: "ChangeOwnPassword",
  type: "global",
  enablingScopes: ["backoffice_access", "system_superadmin"],
};
const GetPropertyInfo: Action = {
  id: "GetPropertyInfo",
  type: "property",
  enablingScopes: ["property:read", "property:superadmin"],
};
const ListReservations: Action = {
  id: "ListReservations",
  type: "property",
  enablingScopes: ["*"],
};
const ListReservationsExtended: Action = {
  id: "ListReservationsExtended",
  type: "property",
  enablingScopes: ["*"],
};
const ViewReservation: Action = {
  id: "ViewReservation",
  type: "property",
  enablingScopes: ["reservations:read", "reservations:modify", "property:superadmin"],
};
const GetReservationTransactions: Action = {
  id: "GetReservationTransactions",
  type: "property",
  enablingScopes: ["*"],
};
const ViewExtendedReservationStats: Action = {
  id: "ViewExtendedReservationStats",
  type: "property",
  enablingScopes: [
    "reservations:read",
    "reports:view",
    "reports:view-privileged",
    "property:superadmin",
  ],
};
const ResendCustomerEmail: Action = {
  id: "ResendCustomerEmail",
  type: "property",
  enablingScopes: ["*"],
};
const ResendHotelEmail: Action = {
  id: "ResendHotelEmail",
  type: "property",
  enablingScopes: ["*"],
};
const ModifyReservation: Action = {
  id: "ModifyReservation",
  type: "property",
  enablingScopes: ["reservations:modify", "property:superadmin"],
};
const CancelReservation: Action = {
  id: "CancelReservation",
  type: "property",
  enablingScopes: ["*"],
};
const ConfirmReservation: Action = {
  id: "ConfirmReservation",
  type: "property",
  enablingScopes: ["*"],
};
const ViewReservationPayment: Action = {
  id: "ViewReservationPayment",
  type: "property",
  enablingScopes: ["reservations:modify", "property:superadmin"],
};
const AddChargeToReservation: Action = {
  id: "AddChargeToReservation",
  type: "property",
  enablingScopes: ["*"],
};
const RefundChargeToReservation: Action = {
  id: "RefundChargeToReservation",
  type: "property",
  enablingScopes: ["*"],
};
const ViewInventory: Action = {
  id: "ViewInventory",
  type: "property",
  enablingScopes: [
    "inventory:view",
    "inventory:modify",
    "property:superadmin",
    "inventory_management:view",
    "inventory_management:modify",
  ],
};
const ViewExtra: Action = {
  id: "ViewExtra",
  type: "property",
  enablingScopes: [
    "inventory:view",
    "inventory:modify",
    "property:superadmin",
    "extras:view",
    "extras:modify",
  ],
};
const ViewPromo: Action = {
  id: "ViewPromo",
  type: "property",
  enablingScopes: [
    "inventory:view",
    "inventory:modify",
    "property:superadmin",
    "promos:view",
    "promos:modify",
  ],
};
const ViewAccomodation: Action = {
  id: "ViewAccomodation",
  type: "property",
  enablingScopes: [
    "inventory:view",
    "inventory:modify",
    "property:superadmin",
    "accommodations:view",
    "accommodations:modify",
  ],
};
const ViewCondition: Action = {
  id: "ViewCondition",
  type: "property",
  enablingScopes: [
    "inventory:view",
    "inventory:modify",
    "property:superadmin",
    "conditions:view",
    "conditions:modify",
  ],
};
const ViewMealPlan: Action = {
  id: "ViewMealPlan",
  type: "property",
  enablingScopes: [
    "inventory:view",
    "inventory:modify",
    "property:superadmin",
    "meal_plans:view",
    "meal_plans:modify",
  ],
};
const ViewInventoryLine: Action = {
  id: "ViewInventoryLine",
  type: "property",
  enablingScopes: [
    "inventory:view",
    "inventory:modify",
    "property:superadmin",
    "inventory_management:view",
    "inventory_management:modify",
  ],
};
const ViewDynamicPriceRule: Action = {
  id: "ViewDynamicPriceRule",
  type: "property",
  enablingScopes: ["inventory:view", "inventory:modify", "property:superadmin"],
};
const ViewOccupation: Action = {
  id: "ViewOccupation",
  type: "property",
  enablingScopes: [
    "inventory:view",
    "inventory:modify",
    "property:superadmin",
    "occupations:view",
    "occupations:modify",
  ],
};
const ExportInventoryLines: Action = {
  id: "ExportInventoryLines",
  type: "property",
  enablingScopes: [
    "inventory:view",
    "inventory:modify",
    "property:superadmin",
    "inventory_management:modify",
  ],
};
const ModifyInventory: Action = {
  id: "ModifyInventory",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "inventory_management:modify"],
};
const CreateExtra: Action = {
  id: "CreateExtra",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "extras:modify"],
};
const ModifyExtra: Action = {
  id: "ModifyExtra",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "extras:modify"],
};
const DeleteExtra: Action = {
  id: "DeleteExtra",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "extras:modify"],
};
const CreatePromo: Action = {
  id: "CreatePromo",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "promos:modify"],
};
const ModifyPromo: Action = {
  id: "ModifyPromo",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "promos:modify"],
};
const DeletePromo: Action = {
  id: "DeletePromo",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "promos:modify"],
};
const CreateAccomodation: Action = {
  id: "CreateAccomodation",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "accommodations:modify"],
};
const ModifyAccomodation: Action = {
  id: "ModifyAccomodation",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "accommodations:modify"],
};
const DeleteAccomodation: Action = {
  id: "DeleteAccomodation",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "accommodations:modify"],
};
const CreateOccupation: Action = {
  id: "CreateOccupation",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "occupations:modify"],
};
const ModifyOccupation: Action = {
  id: "ModifyOccupation",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "occupations:modify"],
};
const DeleteOccupation: Action = {
  id: "DeleteOccupation",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "occupations:modify"],
};
const CreateCondition: Action = {
  id: "CreateCondition",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "conditions:modify"],
};
const ModifyCondition: Action = {
  id: "ModifyCondition",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "conditions:modify"],
};
const DeleteCondition: Action = {
  id: "DeleteCondition",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "conditions:modify"],
};
const ModifyMealPlan: Action = {
  id: "ModifyMealPlan",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "meal_plans:modify"],
};
const CreateInventoryLine: Action = {
  id: "CreateInventoryLine",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "inventory_management:modify"],
};
const ModifyInventoryLine: Action = {
  id: "ModifyInventoryLine",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "inventory_management:modify"],
};
const DeleteInventoryLine: Action = {
  id: "DeleteInventoryLine",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "inventory_management:modify"],
};
const ImportInventoryLines: Action = {
  id: "ImportInventoryLines",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "inventory_management:modify"],
};
const CreateDynamicPriceRule: Action = {
  id: "CreateDynamicPriceRule",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin"],
};
const ModifyDynamicPriceRule: Action = {
  id: "ModifyDynamicPriceRule",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin"],
};
const DeleteDynamicPriceRule: Action = {
  id: "DeleteDynamicPriceRule",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin"],
};
const CreateMealPlan: Action = {
  id: "CreateMealPlan",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "meal_plans:modify"],
};
const DeleteMealPlan: Action = {
  id: "DeleteMealPlan",
  type: "property",
  enablingScopes: ["inventory:modify", "property:superadmin", "meal_plans:modify"],
};
const ViewGoogleAnalyticsSettings: Action = {
  id: "ViewGoogleAnalyticsSettings",
  type: "property",
  enablingScopes: ["integrations:view", "integrations:modify", "property:superadmin"],
};
const ViewCustomMarkup: Action = {
  id: "ViewCustomMarkup",
  type: "property",
  enablingScopes: ["integrations:view", "integrations:modify", "property:superadmin"],
};
const ModifyGoogleAnalyticsSettings: Action = {
  id: "ModifyGoogleAnalyticsSettings",
  type: "property",
  enablingScopes: ["integrations:modify", "property:superadmin"],
};
const CreateCustomMarkup: Action = {
  id: "CreateCustomMarkup",
  type: "property",
  enablingScopes: ["integrations:modify", "property:superadmin"],
};
const ModifyCustomMarkup: Action = {
  id: "ModifyCustomMarkup",
  type: "property",
  enablingScopes: ["integrations:modify", "property:superadmin"],
};
const DeleteCustomMarkup: Action = {
  id: "DeleteCustomMarkup",
  type: "property",
  enablingScopes: ["integrations:modify", "property:superadmin"],
};
const ViewReservationStats: Action = {
  id: "ViewReservationStats",
  type: "property",
  enablingScopes: ["reports:view", "reports:view-privileged", "property:superadmin"],
};
const ViewStaysPerDay: Action = {
  id: "ViewStaysPerDay",
  type: "property",
  enablingScopes: ["reports:view", "reports:view-privileged", "property:superadmin"],
};
const ViewQueryStats: Action = {
  id: "ViewQueryStats",
  type: "property",
  enablingScopes: ["reports:view", "reports:view-privileged", "property:superadmin"],
};
const ViewWaitingListReport: Action = {
  id: "ViewWaitingListReport",
  type: "property",
  enablingScopes: ["reports:view", "property:superadmin", "system_superadmin"],
};
const ViewBillingReport: Action = {
  id: "ViewBillingReport",
  type: "global",
  enablingScopes: ["crm_viewer", "crm_editor", "system_superadmin"],
};
const ViewWebMessage: Action = {
  id: "ViewWebMessage",
  type: "property",
  enablingScopes: ["communication:view", "communication:modify", "property:superadmin"],
};
const ViewAlertSettings: Action = {
  id: "ViewAlertSettings",
  type: "property",
  enablingScopes: ["communication:view", "communication:modify", "property:superadmin"],
};
const ViewEmailListing: Action = {
  id: "ViewEmailListing",
  type: "property",
  enablingScopes: ["communication:view", "communication:modify", "property:superadmin"],
};
const ViewPreStayEmailSettings: Action = {
  id: "ViewPreStayEmailSettings",
  type: "property",
  enablingScopes: ["communication:view", "communication:modify", "property:superadmin"],
};
const ViewPostStayEmailSettings: Action = {
  id: "ViewPostStayEmailSettings",
  type: "property",
  enablingScopes: ["communication:view", "communication:modify", "property:superadmin"],
};
const ViewPostStayPollSettings: Action = {
  id: "ViewPostStayPollSettings",
  type: "property",
  enablingScopes: ["communication:view", "communication:modify", "property:superadmin"],
};
const ViewPostStayPollResults: Action = {
  id: "ViewPostStayPollResults",
  type: "property",
  enablingScopes: ["communication:view", "communication:modify", "property:superadmin"],
};
const ViewConfirmationEmailSettings: Action = {
  id: "ViewConfirmationEmailSettings",
  type: "property",
  enablingScopes: ["communication:view", "communication:modify", "property:superadmin"],
};
const CreateWebMessage: Action = {
  id: "CreateWebMessage",
  type: "property",
  enablingScopes: ["communication:modify", "property:superadmin"],
};
const ModifyWebMessage: Action = {
  id: "ModifyWebMessage",
  type: "property",
  enablingScopes: ["communication:modify", "property:superadmin"],
};
const DeleteWebMessage: Action = {
  id: "DeleteWebMessage",
  type: "property",
  enablingScopes: ["communication:modify", "property:superadmin"],
};
const ModifyAlertSettings: Action = {
  id: "ModifyAlertSettings",
  type: "property",
  enablingScopes: ["communication:modify", "property:superadmin"],
};
const ModifyConfirmationEmailSettings: Action = {
  id: "ModifyConfirmationEmailSettings",
  type: "property",
  enablingScopes: ["communication:modify", "property:superadmin"],
};
const ModifyPreStayEmailSettings: Action = {
  id: "ModifyPreStayEmailSettings",
  type: "property",
  enablingScopes: ["communication:modify", "property:superadmin"],
};
const ModifyPostStayEmailSettings: Action = {
  id: "ModifyPostStayEmailSettings",
  type: "property",
  enablingScopes: ["communication:modify", "property:superadmin"],
};
const ModifyPostStayPollSettings: Action = {
  id: "ModifyPostStayPollSettings",
  type: "property",
  enablingScopes: ["communication:modify", "property:superadmin"],
};
const ViewForm: Action = {
  id: "ViewForm",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewCustomEmail: Action = {
  id: "ViewCustomEmail",
  type: "global",
  enablingScopes: [
    "system_superadmin",
    "email-admin",
    "c2t-admin",
    "camping-admin",
    "camping-fr-admin",
    "aci-admin",
  ],
};
const ViewPropertyInfo: Action = {
  id: "ViewPropertyInfo",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewBehaviorSettings: Action = {
  id: "ViewBehaviorSettings",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewLanguageSettings: Action = {
  id: "ViewLanguageSettings",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewCustomerInfoSettings: Action = {
  id: "ViewCustomerInfoSettings",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewCurrencySettings: Action = {
  id: "ViewCurrencySettings",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewTaxSettings: Action = {
  id: "ViewTaxSettings",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewCreditCardSettings: Action = {
  id: "ViewCreditCardSettings",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewPaymentMethod: Action = {
  id: "ViewPaymentMethod",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewOccupantSettings: Action = {
  id: "ViewOccupantSettings",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewInventorySettings: Action = {
  id: "ViewInventorySettings",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewAppeareanceSettings: Action = {
  id: "ViewAppeareanceSettings",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewDisplay: Action = {
  id: "ViewDisplay",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewLegalInfo: Action = {
  id: "ViewLegalInfo",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewReservationModificationPolicy: Action = {
  id: "ViewReservationModificationPolicy",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewCancellationPolicy: Action = {
  id: "ViewCancellationPolicy",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewTaxConfiguration: Action = {
  id: "ViewTaxConfiguration",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewCustomMaps: Action = {
  id: "ViewCustomMaps",
  type: "property",
  enablingScopes: [
    "propertyconfig:view",
    "propertyconfig:modify",
    "property:superadmin",
    "custom_map:view",
    "custom_map:modify",
  ],
};
const ViewBundles: Action = {
  id: "ViewBundles",
  type: "property",
  enablingScopes: ["propertyconfig:view", "propertyconfig:modify", "property:superadmin"],
};
const ViewQuotation: Action = {
  id: "ViewQuotation",
  type: "property",
  enablingScopes: [
    "property:read",
    "propertyconfig:view",
    "propertyconfig:modify",
    "property:superadmin",
  ],
};
const CreateForm: Action = {
  id: "CreateForm",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyForm: Action = {
  id: "ModifyForm",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const DeleteForm: Action = {
  id: "DeleteForm",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const CreateCustomEmail: Action = {
  id: "CreateCustomEmail",
  type: "global",
  enablingScopes: [
    "system_superadmin",
    "email-admin",
    "c2t-admin",
    "camping-admin",
    "camping-fr-admin",
    "aci-admin",
  ],
};
const ModifyCustomEmail: Action = {
  id: "ModifyCustomEmail",
  type: "global",
  enablingScopes: [
    "system_superadmin",
    "email-admin",
    "c2t-admin",
    "camping-admin",
    "camping-fr-admin",
    "aci-admin",
  ],
};
const DeleteCustomEmail: Action = {
  id: "DeleteCustomEmail",
  type: "global",
  enablingScopes: [
    "system_superadmin",
    "email-admin",
    "c2t-admin",
    "camping-admin",
    "camping-fr-admin",
    "aci-admin",
  ],
};
const ModifyPropertyInfo: Action = {
  id: "ModifyPropertyInfo",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyBehaviorSettings: Action = {
  id: "ModifyBehaviorSettings",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyLanguageSettings: Action = {
  id: "ModifyLanguageSettings",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyCustomerInfoSettings: Action = {
  id: "ModifyCustomerInfoSettings",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyCurrencySettings: Action = {
  id: "ModifyCurrencySettings",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyTaxSettings: Action = {
  id: "ModifyTaxSettings",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyCreditCardSettings: Action = {
  id: "ModifyCreditCardSettings",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyPaymentMethod: Action = {
  id: "ModifyPaymentMethod",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyOccupantSettings: Action = {
  id: "ModifyOccupantSettings",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyInventorySettings: Action = {
  id: "ModifyInventorySettings",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyAppeareanceSettings: Action = {
  id: "ModifyAppeareanceSettings",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const CreateDisplay: Action = {
  id: "CreateDisplay",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyDisplay: Action = {
  id: "ModifyDisplay",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const DeleteDisplay: Action = {
  id: "DeleteDisplay",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const CreateLegalInfo: Action = {
  id: "CreateLegalInfo",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyLegalInfo: Action = {
  id: "ModifyLegalInfo",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const DeleteLegalInfo: Action = {
  id: "DeleteLegalInfo",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const CreateReservationModificationPolicy: Action = {
  id: "CreateReservationModificationPolicy",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyReservationModificationPolicy: Action = {
  id: "ModifyReservationModificationPolicy",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const DeleteReservationModificationPolicy: Action = {
  id: "DeleteReservationModificationPolicy",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const CreateCancellationPolicy: Action = {
  id: "CreateCancellationPolicy",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyCancellationPolicy: Action = {
  id: "ModifyCancellationPolicy",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const DeleteCancellationPolicy: Action = {
  id: "DeleteCancellationPolicy",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyTaxConfiguration: Action = {
  id: "ModifyTaxConfiguration",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyCustomMaps: Action = {
  id: "ModifyCustomMaps",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin", "custom_map:modify"],
};
const ModifyBundles: Action = {
  id: "ModifyBundles",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const ModifyQuotation: Action = {
  id: "ModifyQuotation",
  type: "property",
  enablingScopes: ["property:read", "propertyconfig:modify", "property:superadmin"],
};
const CreateBundles: Action = {
  id: "CreateBundles",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const DeleteBundles: Action = {
  id: "DeleteBundles",
  type: "property",
  enablingScopes: ["propertyconfig:modify", "property:superadmin"],
};
const CreateQuotation: Action = {
  id: "CreateQuotation",
  type: "property",
  enablingScopes: ["property:read", "propertyconfig:modify", "property:superadmin"],
};
const DeleteQuotation: Action = {
  id: "DeleteQuotation",
  type: "property",
  enablingScopes: ["property:read", "propertyconfig:modify", "property:superadmin"],
};
const ViewPropertyUsers: Action = {
  id: "ViewPropertyUsers",
  type: "property",
  enablingScopes: ["property:am", "property:superadmin"],
};
const CreateUser: Action = {
  id: "CreateUser",
  type: "global",
  enablingScopes: ["user_manager", "system_superadmin"],
};
const ChangeUserPassword: Action = {
  id: "ChangeUserPassword",
  type: "global",
  enablingScopes: ["user_manager", "system_superadmin"],
};
const CreateProperty: Action = {
  id: "CreateProperty",
  type: "global",
  enablingScopes: ["system_manager", "system_superadmin"],
};
const ExecuteBatchSQLQuery: Action = {
  id: "ExecuteBatchSQLQuery",
  type: "global",
  enablingScopes: ["system_manager", "system_superadmin"],
};
const ReplicateProperty: Action = {
  id: "ReplicateProperty",
  type: "global",
  enablingScopes: ["system_manager", "system_superadmin"],
};
const ViewGlobalEmailList: Action = {
  id: "ViewGlobalEmailList",
  type: "global",
  enablingScopes: ["system_manager", "system_superadmin"],
};
const ViewSiteminderSettings: Action = {
  id: "ViewSiteminderSettings",
  type: "global",
  enablingScopes: ["system_manager", "system_superadmin"],
};
const ModifySiteminderSettings: Action = {
  id: "ModifySiteminderSettings",
  type: "global",
  enablingScopes: ["system_manager", "system_superadmin"],
};
const ViewTripAdvisorRESettings: Action = {
  id: "ViewTripAdvisorRESettings",
  type: "global",
  enablingScopes: ["system_manager", "system_superadmin"],
};
const ModifyTripAdvisorRESettings: Action = {
  id: "ModifyTripAdvisorRESettings",
  type: "global",
  enablingScopes: ["system_manager", "system_superadmin"],
};
const ViewRategainSettings: Action = {
  id: "ViewRategainSettings",
  type: "global",
  enablingScopes: ["system_manager", "system_superadmin"],
};
const ModifyRategainSettings: Action = {
  id: "ModifyRategainSettings",
  type: "global",
  enablingScopes: ["system_manager", "system_superadmin"],
};
const ViewParityRateSettings: Action = {
  id: "ViewParityRateSettings",
  type: "global",
  enablingScopes: ["system_manager", "system_superadmin"],
};
const ModifyParityRateSettings: Action = {
  id: "ModifyParityRateSettings",
  type: "global",
  enablingScopes: ["system_manager", "system_superadmin"],
};
const ViewPropertyParameters: Action = {
  id: "ViewPropertyParameters",
  type: "property",
  enablingScopes: ["property:manage", "property:superadmin"],
};
const ModifyPropertyParameters: Action = {
  id: "ModifyPropertyParameters",
  type: "property",
  enablingScopes: ["property:manage", "property:superadmin"],
};
const ViewClient: Action = {
  id: "ViewClient",
  type: "global",
  enablingScopes: ["crm_viewer", "crm_editor", "system_superadmin"],
};
const ViewCrmProperty: Action = {
  id: "ViewCrmProperty",
  type: "global",
  enablingScopes: ["crm_viewer", "crm_editor", "system_superadmin"],
};
const ViewService: Action = {
  id: "ViewService",
  type: "global",
  enablingScopes: ["crm_viewer", "crm_editor", "system_superadmin"],
};
const ViewContract: Action = {
  id: "ViewContract",
  type: "global",
  enablingScopes: ["crm_viewer", "crm_editor", "system_superadmin"],
};
const ViewPartner: Action = {
  id: "ViewPartner",
  type: "global",
  enablingScopes: ["crm_viewer", "crm_editor", "system_superadmin"],
};
const ViewCRMBillingReport: Action = {
  id: "ViewCRMBillingReport",
  type: "global",
  enablingScopes: ["crm_viewer", "crm_editor", "system_superadmin"],
};
const CreateClient: Action = {
  id: "CreateClient",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const ModifyClient: Action = {
  id: "ModifyClient",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const DeleteClient: Action = {
  id: "DeleteClient",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const CreateCrmProperty: Action = {
  id: "CreateCrmProperty",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const ModifyCrmProperty: Action = {
  id: "ModifyCrmProperty",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const DeleteCrmProperty: Action = {
  id: "DeleteCrmProperty",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const CreateService: Action = {
  id: "CreateService",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const ModifyService: Action = {
  id: "ModifyService",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const DeleteService: Action = {
  id: "DeleteService",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const CreateContract: Action = {
  id: "CreateContract",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const ModifyContract: Action = {
  id: "ModifyContract",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const DeleteContract: Action = {
  id: "DeleteContract",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const CreatePartner: Action = {
  id: "CreatePartner",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const ModifyPartner: Action = {
  id: "ModifyPartner",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const DeletePartner: Action = {
  id: "DeletePartner",
  type: "global",
  enablingScopes: ["crm_editor", "system_superadmin"],
};
const ViewFilter: Action = {
  id: "ViewFilter",
  type: "property",
  enablingScopes: ["property:superadmin", "filters:view", "filters:modify"],
};
const CreateFilter: Action = {
  id: "CreateFilter",
  type: "property",
  enablingScopes: ["property:superadmin", "filters:modify"],
};
const ModifyFilter: Action = {
  id: "ModifyFilter",
  type: "property",
  enablingScopes: ["property:superadmin", "filters:modify"],
};
const DeleteFilter: Action = {
  id: "DeleteFilter",
  type: "property",
  enablingScopes: ["property:superadmin", "filters:modify"],
};
const CheckInventoryIntegrity: Action = {
  id: "CheckInventoryIntegrity",
  type: "property",
  enablingScopes: ["property:superadmin"],
};
const CreatePaymentMethod: Action = {
  id: "CreatePaymentMethod",
  type: "property",
  enablingScopes: ["property:superadmin"],
};
const DeletePaymentMethod: Action = {
  id: "DeletePaymentMethod",
  type: "property",
  enablingScopes: ["property:superadmin"],
};
const ViewLoyaltyCustomers: Action = {
  id: "ViewLoyaltyCustomers",
  type: "property",
  enablingScopes: [
    "property:superadmin",
    "loyalty-customers:view",
    "loyalty-customers:modify",
    "callcenter",
    "callcenter_light_user",
  ],
};
const CreateLoyaltyCustomers: Action = {
  id: "CreateLoyaltyCustomers",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-customers:modify"],
};
const ModifyLoyaltyCustomers: Action = {
  id: "ModifyLoyaltyCustomers",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-customers:modify"],
};
const DeleteLoyaltyCustomers: Action = {
  id: "DeleteLoyaltyCustomers",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-customers:modify"],
};
const ViewConstantLoyaltyTiers: Action = {
  id: "ViewConstantLoyaltyTiers",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-tiers:view", "loyalty-tiers:modify"],
};
const CreateConstantLoyaltyTiers: Action = {
  id: "CreateConstantLoyaltyTiers",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-tiers:modify"],
};
const ModifyConstantLoyaltyTiers: Action = {
  id: "ModifyConstantLoyaltyTiers",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-tiers:modify"],
};
const DeleteConstantLoyaltyTiers: Action = {
  id: "DeleteConstantLoyaltyTiers",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-tiers:modify"],
};
const ViewDerivedLoyaltyTiers: Action = {
  id: "ViewDerivedLoyaltyTiers",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-tiers:view", "loyalty-tiers:modify"],
};
const CreateDerivedLoyaltyTiers: Action = {
  id: "CreateDerivedLoyaltyTiers",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-tiers:modify"],
};
const ModifyDerivedLoyaltyTiers: Action = {
  id: "ModifyDerivedLoyaltyTiers",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-tiers:modify"],
};
const DeleteDerivedLoyaltyTiers: Action = {
  id: "DeleteDerivedLoyaltyTiers",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-tiers:modify"],
};
const ViewLoyaltyOrganizations: Action = {
  id: "ViewLoyaltyOrganizations",
  type: "property",
  enablingScopes: [
    "property:superadmin",
    "loyalty-organizations:view",
    "loyalty-organizations:modify",
  ],
};
const CreateLoyaltyOrganizations: Action = {
  id: "CreateLoyaltyOrganizations",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-organizations:modify"],
};
const ModifyLoyaltyOrganizations: Action = {
  id: "ModifyLoyaltyOrganizations",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-organizations:modify"],
};
const DeleteLoyaltyOrganizations: Action = {
  id: "DeleteLoyaltyOrganizations",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty-organizations:modify"],
};
const ViewLoyaltyCustomerHistorical: Action = {
  id: "ViewLoyaltyCustomerHistorical",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty_customer_historical:view"],
};
const ModifyLoyaltyCustomerHistorical: Action = {
  id: "ModifyLoyaltyCustomerHistorical",
  type: "property",
  enablingScopes: ["property:superadmin", "loyalty_customer_historical:modify"],
};
const ViewLoyaltyBrandManager: Action = {
  id: "ViewLoyaltyBrandManager",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ModifyLoyaltyBrandManager: Action = {
  id: "ModifyLoyaltyBrandManager",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ViewDashboard: Action = {
  id: "ViewDashboard",
  type: "property",
  enablingScopes: ["property:superadmin", "system_superadmin", "dashboard:view"],
};
const ViewTaxes: Action = {
  id: "ViewTaxes",
  type: "property",
  enablingScopes: ["property:superadmin", "taxes:view", "taxes:modify"],
};
const ModifyTaxes: Action = {
  id: "ModifyTaxes",
  type: "property",
  enablingScopes: ["property:superadmin", "taxes:modify"],
};
const CreateTaxes: Action = {
  id: "CreateTaxes",
  type: "property",
  enablingScopes: ["property:superadmin", "taxes:modify"],
};
const DeleteTaxes: Action = {
  id: "DeleteTaxes",
  type: "property",
  enablingScopes: ["property:superadmin", "taxes:modify"],
};
const ViewTags: Action = {
  id: "ViewTags",
  type: "property",
  enablingScopes: ["property:superadmin", "tags:view", "tags:modify"],
};
const CreateTags: Action = {
  id: "CreateTags",
  type: "property",
  enablingScopes: ["property:superadmin", "tags:modify"],
};
const ModifyTags: Action = {
  id: "ModifyTags",
  type: "property",
  enablingScopes: ["property:superadmin", "tags:modify"],
};
const ViewChannelLogs: Action = {
  id: "ViewChannelLogs",
  type: "global",
  enablingScopes: ["system_superadmin", "camping-admin", "camping-fr-admin", "aci-admin"],
};
const ResendReservationToChannel: Action = {
  id: "ResendReservationToChannel",
  type: "global",
  enablingScopes: ["system_superadmin", "camping-admin", "camping-fr-admin", "aci-admin"],
};
const UpdatePropertyChannelManagers: Action = {
  id: "UpdatePropertyChannelManagers",
  type: "global",
  enablingScopes: ["system_superadmin", "camping-admin", "camping-fr-admin", "aci-admin"],
};
const ViewGoogleFeed: Action = {
  id: "ViewGoogleFeed",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ViewQueryExecutor: Action = {
  id: "ViewQueryExecutor",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ViewChainConfigurer: Action = {
  id: "ViewChainConfigurer",
  type: "global",
  enablingScopes: [
    "system_superadmin",
    "c2t-admin",
    "camping-admin",
    "camping-fr-admin",
    "aci-admin",
  ],
};
const ModifyAccessToProperty: Action = {
  id: "ModifyAccessToProperty",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ViewPropertyConfiguration: Action = {
  id: "ViewPropertyConfiguration",
  type: "global",
  enablingScopes: ["system_superadmin", "camping-admin", "camping-fr-admin", "aci-admin"],
};
const ModifyPropertyConfiguration: Action = {
  id: "ModifyPropertyConfiguration",
  type: "global",
  enablingScopes: ["system_superadmin", "camping-admin", "camping-fr-admin", "aci-admin"],
};
const ViewIntegrationParameters: Action = {
  id: "ViewIntegrationParameters",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ModifyIntegrationParameters: Action = {
  id: "ModifyIntegrationParameters",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ViewAriSnapshot: Action = {
  id: "ViewAriSnapshot",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ViewCalendarRegen: Action = {
  id: "ViewCalendarRegen",
  type: "global",
  enablingScopes: [
    "system_superadmin",
    "c2t-admin",
    "camping-admin",
    "camping-fr-admin",
    "aci-admin",
  ],
};
const CreateUserBatch: Action = {
  id: "CreateUserBatch",
  type: "global",
  enablingScopes: [
    "system_superadmin",
    "c2t-admin",
    "camping-admin",
    "camping-fr-admin",
    "aci-admin",
  ],
};
const EditUserBatch: Action = {
  id: "EditUserBatch",
  type: "global",
  enablingScopes: [
    "system_superadmin",
    "c2t-admin",
    "camping-admin",
    "camping-fr-admin",
    "aci-admin",
  ],
};
const ShowEmailBlacklist: Action = {
  id: "ShowEmailBlacklist",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const GenerateBillingReport: Action = {
  id: "GenerateBillingReport",
  type: "global",
  enablingScopes: ["crm_admin"],
};
const ViewCustomWeb: Action = {
  id: "ViewCustomWeb",
  type: "property",
  enablingScopes: ["custom-web:view", "custom-web:modify"],
};
const ModifyCustomWeb: Action = {
  id: "ModifyCustomWeb",
  type: "property",
  enablingScopes: ["custom-web:modify"],
};
const ExportMaskedData: Action = {
  id: "ExportMaskedData",
  type: "property",
  enablingScopes: ["masked-data:view"],
};
const SendUnmaskedData: Action = {
  id: "SendUnmaskedData",
  type: "global",
  enablingScopes: ["unmasked_data_sender"],
};
const DownloadCustomersExcel: Action = {
  id: "DownloadCustomersExcel",
  type: "property",
  enablingScopes: ["loyalty-customers:download"],
};
const ViewEngineMultiConfig: Action = {
  id: "ViewEngineMultiConfig",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const CreateEngineMultiConfig: Action = {
  id: "CreateEngineMultiConfig",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ModifyEngineMultiConfig: Action = {
  id: "ModifyEngineMultiConfig",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const DeleteEngineMultiConfig: Action = {
  id: "DeleteEngineMultiConfig",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ViewLoyaltyPreferences: Action = {
  id: "ViewLoyaltyPreferences",
  type: "property",
  enablingScopes: ["loyalty-preferences:view", "loyalty-preferences:modify"],
};
const CreateLoyaltyPreferences: Action = {
  id: "CreateLoyaltyPreferences",
  type: "property",
  enablingScopes: ["loyalty-preferences:modify"],
};
const ModifyLoyaltyPreferences: Action = {
  id: "ModifyLoyaltyPreferences",
  type: "property",
  enablingScopes: ["loyalty-preferences:modify"],
};
const DeleteLoyaltyPreferences: Action = {
  id: "DeleteLoyaltyPreferences",
  type: "property",
  enablingScopes: ["loyalty-preferences:modify"],
};
const ViewSellingConfiguration: Action = {
  id: "ViewSellingConfiguration",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const CreateSellingConfiguration: Action = {
  id: "CreateSellingConfiguration",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ModifySellingConfiguration: Action = {
  id: "ModifySellingConfiguration",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const DeleteSellingConfiguration: Action = {
  id: "DeleteSellingConfiguration",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ViewUpgradeManager: Action = {
  id: "ViewUpgradeManager",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const CreateUpgradeConfiguration: Action = {
  id: "CreateUpgradeConfiguration",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ModifyUpgradeConfiguration: Action = {
  id: "ModifyUpgradeConfiguration",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const DeleteUpgradeConfiguration: Action = {
  id: "DeleteUpgradeConfiguration",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const UserPropertiesManager: Action = {
  id: "UserPropertiesManager",
  type: "global",
  enablingScopes: [
    "system_superadmin",
    "c2t-admin",
    "camping-admin",
    "camping-fr-admin",
    "aci-admin",
  ],
};
const ViewStoreOrders: Action = {
  id: "ViewStoreOrders",
  type: "property",
  enablingScopes: ["store-orders:view"],
};
const ViewStoreProducts: Action = {
  id: "ViewStoreProducts",
  type: "property",
  enablingScopes: ["store-products:view", "store-products:modify"],
};
const CreateStoreProducts: Action = {
  id: "CreateStoreProducts",
  type: "property",
  enablingScopes: ["store-products:modify"],
};
const ModifyStoreProducts: Action = {
  id: "ModifyStoreProducts",
  type: "property",
  enablingScopes: ["store-products:modify"],
};
const DeleteStoreProducts: Action = {
  id: "DeleteStoreProducts",
  type: "property",
  enablingScopes: ["store-products:modify"],
};
const ViewFunctionalityReport: Action = {
  id: "ViewFunctionalityReport",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ViewOrchestratorGlobalActions: Action = {
  id: "ViewOrchestratorGlobalActions",
  type: "property",
  enablingScopes: ["orchestrator:view"],
};
const CreateOrchestratorGlobalActions: Action = {
  id: "CreateOrchestratorGlobalActions",
  type: "property",
  enablingScopes: ["orchestrator:view", "orchestrator:modify"],
};
const ModifyOrchestratorGlobalActions: Action = {
  id: "ModifyOrchestratorGlobalActions",
  type: "property",
  enablingScopes: ["orchestrator:view", "orchestrator:modify"],
};
const DeleteOrchestratorGlobalActions: Action = {
  id: "DeleteOrchestratorGlobalActions",
  type: "property",
  enablingScopes: ["orchestrator:view", "orchestrator:modify"],
};
const ViewOrchestratorSegments: Action = {
  id: "ViewOrchestratorSegments",
  type: "property",
  enablingScopes: ["orchestrator:view"],
};
const CreateOrchestratorSegments: Action = {
  id: "CreateOrchestratorSegments",
  type: "property",
  enablingScopes: ["orchestrator:view", "orchestrator:modify"],
};
const ModifyOrchestratorSegments: Action = {
  id: "ModifyOrchestratorSegments",
  type: "property",
  enablingScopes: ["orchestrator:view", "orchestrator:modify"],
};
const DeleteOrchestratorSegments: Action = {
  id: "DeleteOrchestratorSegments",
  type: "property",
  enablingScopes: ["orchestrator:view", "orchestrator:modify"],
};
const ViewOrchestratorScenarios: Action = {
  id: "ViewOrchestratorScenarios",
  type: "property",
  enablingScopes: ["orchestrator:view"],
};
const CreateOrchestratorScenarios: Action = {
  id: "CreateOrchestratorScenarios",
  type: "property",
  enablingScopes: ["orchestrator:view", "orchestrator:modify"],
};
const ModifyOrchestratorScenarios: Action = {
  id: "ModifyOrchestratorScenarios",
  type: "property",
  enablingScopes: ["orchestrator:view", "orchestrator:modify"],
};
const DeleteOrchestratorScenarios: Action = {
  id: "DeleteOrchestratorScenarios",
  type: "property",
  enablingScopes: ["orchestrator:view", "orchestrator:modify"],
};
const ViewOrchestratorExperiments: Action = {
  id: "ViewOrchestratorExperiments",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const CreateOrchestratorExperiments: Action = {
  id: "CreateOrchestratorExperiments",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ModifyOrchestratorExperiments: Action = {
  id: "ModifyOrchestratorExperiments",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const DeleteOrchestratorExperiments: Action = {
  id: "DeleteOrchestratorExperiments",
  type: "global",
  enablingScopes: ["system_superadmin"],
};
const ViewInsurances: Action = {
  id: "ViewInsurances",
  type: "property",
  enablingScopes: ["property:superadmin", "insurances:view"],
};
const CreateInsurances: Action = {
  id: "CreateInsurances",
  type: "property",
  enablingScopes: ["property:superadmin", "insurances:modify"],
};
const ModifyInsurances: Action = {
  id: "ModifyInsurances",
  type: "property",
  enablingScopes: ["property:superadmin", "insurances:modify"],
};
const DeleteInsurances: Action = {
  id: "DeleteInsurances",
  type: "property",
  enablingScopes: ["property:superadmin", "insurances:modify"],
};
const ViewCampingMap: Action = {
  id: "ViewCampingMap",
  type: "global",
  enablingScopes: ["system_superadmin", "c2t-admin", "camping-admin", "camping-fr-admin"],
};
const ModifyCampingMap: Action = {
  id: "ModifyCampingMap",
  type: "global",
  enablingScopes: ["system_superadmin", "c2t-admin", "camping-admin", "camping-fr-admin"],
};
const ViewCampingMapping: Action = {
  id: "ViewCampingMapping",
  type: "global",
  enablingScopes: ["system_superadmin", "camping-admin", "camping-fr-admin"],
};
const ModifyCampingMapping: Action = {
  id: "ModifyCampingMapping",
  type: "global",
  enablingScopes: ["system_superadmin", "camping-admin", "camping-fr-admin"],
};
const ViewEngineFilters: Action = {
  id: "ViewEngineFilters",
  type: "property",
  enablingScopes: [
    "property:read",
    "property:superadmin",
    "engine-filters:view",
    "engine-filters:modify",
  ],
};
const CreateEngineFilters: Action = {
  id: "CreateEngineFilters",
  type: "property",
  enablingScopes: ["property:superadmin", "engine-filters:modify"],
};
const ModifyEngineFilters: Action = {
  id: "ModifyEngineFilters",
  type: "property",
  enablingScopes: ["property:superadmin", "engine-filters:modify"],
};
const DeleteEngineFilters: Action = {
  id: "DeleteEngineFilters",
  type: "property",
  enablingScopes: ["property:superadmin", "engine-filters:modify"],
};

export default {
  GetPropertyTickers,
  ChangeOwnPassword,
  GetPropertyInfo,
  ListReservations,
  ListReservationsExtended,
  ViewReservation,
  GetReservationTransactions,
  ViewExtendedReservationStats,
  ResendCustomerEmail,
  ResendHotelEmail,
  ModifyReservation,
  CancelReservation,
  ConfirmReservation,
  ViewReservationPayment,
  AddChargeToReservation,
  RefundChargeToReservation,
  ViewInventory,
  ViewExtra,
  ViewPromo,
  ViewAccomodation,
  ViewCondition,
  ViewMealPlan,
  ViewInventoryLine,
  ViewDynamicPriceRule,
  ViewOccupation,
  ExportInventoryLines,
  ModifyInventory,
  CreateExtra,
  ModifyExtra,
  DeleteExtra,
  CreatePromo,
  ModifyPromo,
  DeletePromo,
  CreateAccomodation,
  ModifyAccomodation,
  DeleteAccomodation,
  CreateOccupation,
  ModifyOccupation,
  DeleteOccupation,
  CreateCondition,
  ModifyCondition,
  DeleteCondition,
  ModifyMealPlan,
  CreateInventoryLine,
  ModifyInventoryLine,
  DeleteInventoryLine,
  ImportInventoryLines,
  CreateDynamicPriceRule,
  ModifyDynamicPriceRule,
  DeleteDynamicPriceRule,
  CreateMealPlan,
  DeleteMealPlan,
  ViewGoogleAnalyticsSettings,
  ViewCustomMarkup,
  ModifyGoogleAnalyticsSettings,
  CreateCustomMarkup,
  ModifyCustomMarkup,
  DeleteCustomMarkup,
  ViewReservationStats,
  ViewStaysPerDay,
  ViewQueryStats,
  ViewWaitingListReport,
  ViewBillingReport,
  ViewWebMessage,
  ViewAlertSettings,
  ViewEmailListing,
  ViewPreStayEmailSettings,
  ViewPostStayEmailSettings,
  ViewPostStayPollSettings,
  ViewPostStayPollResults,
  ViewConfirmationEmailSettings,
  CreateWebMessage,
  ModifyWebMessage,
  DeleteWebMessage,
  ModifyAlertSettings,
  ModifyConfirmationEmailSettings,
  ModifyPreStayEmailSettings,
  ModifyPostStayEmailSettings,
  ModifyPostStayPollSettings,
  ViewForm,
  ViewCustomEmail,
  ViewPropertyInfo,
  ViewBehaviorSettings,
  ViewLanguageSettings,
  ViewCustomerInfoSettings,
  ViewCurrencySettings,
  ViewTaxSettings,
  ViewCreditCardSettings,
  ViewPaymentMethod,
  ViewOccupantSettings,
  ViewInventorySettings,
  ViewAppeareanceSettings,
  ViewDisplay,
  ViewLegalInfo,
  ViewReservationModificationPolicy,
  ViewCancellationPolicy,
  ViewTaxConfiguration,
  ViewCustomMaps,
  ViewBundles,
  ViewQuotation,
  CreateForm,
  ModifyForm,
  DeleteForm,
  CreateCustomEmail,
  ModifyCustomEmail,
  DeleteCustomEmail,
  ModifyPropertyInfo,
  ModifyBehaviorSettings,
  ModifyLanguageSettings,
  ModifyCustomerInfoSettings,
  ModifyCurrencySettings,
  ModifyTaxSettings,
  ModifyCreditCardSettings,
  ModifyPaymentMethod,
  ModifyOccupantSettings,
  ModifyInventorySettings,
  ModifyAppeareanceSettings,
  CreateDisplay,
  ModifyDisplay,
  DeleteDisplay,
  CreateLegalInfo,
  ModifyLegalInfo,
  DeleteLegalInfo,
  CreateReservationModificationPolicy,
  ModifyReservationModificationPolicy,
  DeleteReservationModificationPolicy,
  CreateCancellationPolicy,
  ModifyCancellationPolicy,
  DeleteCancellationPolicy,
  ModifyTaxConfiguration,
  ModifyCustomMaps,
  ModifyBundles,
  ModifyQuotation,
  CreateBundles,
  DeleteBundles,
  CreateQuotation,
  DeleteQuotation,
  ViewPropertyUsers,
  CreateUser,
  ChangeUserPassword,
  CreateProperty,
  ExecuteBatchSQLQuery,
  ReplicateProperty,
  ViewGlobalEmailList,
  ViewSiteminderSettings,
  ModifySiteminderSettings,
  ViewTripAdvisorRESettings,
  ModifyTripAdvisorRESettings,
  ViewRategainSettings,
  ModifyRategainSettings,
  ViewParityRateSettings,
  ModifyParityRateSettings,
  ViewPropertyParameters,
  ModifyPropertyParameters,
  ViewClient,
  ViewCrmProperty,
  ViewService,
  ViewContract,
  ViewPartner,
  ViewCRMBillingReport,
  CreateClient,
  ModifyClient,
  DeleteClient,
  CreateCrmProperty,
  ModifyCrmProperty,
  DeleteCrmProperty,
  CreateService,
  ModifyService,
  DeleteService,
  CreateContract,
  ModifyContract,
  DeleteContract,
  CreatePartner,
  ModifyPartner,
  DeletePartner,
  ViewFilter,
  CreateFilter,
  ModifyFilter,
  DeleteFilter,
  CheckInventoryIntegrity,
  CreatePaymentMethod,
  DeletePaymentMethod,
  ViewLoyaltyCustomers,
  CreateLoyaltyCustomers,
  ModifyLoyaltyCustomers,
  DeleteLoyaltyCustomers,
  ViewConstantLoyaltyTiers,
  CreateConstantLoyaltyTiers,
  ModifyConstantLoyaltyTiers,
  DeleteConstantLoyaltyTiers,
  ViewDerivedLoyaltyTiers,
  CreateDerivedLoyaltyTiers,
  ModifyDerivedLoyaltyTiers,
  DeleteDerivedLoyaltyTiers,
  ViewLoyaltyOrganizations,
  CreateLoyaltyOrganizations,
  ModifyLoyaltyOrganizations,
  DeleteLoyaltyOrganizations,
  ViewLoyaltyCustomerHistorical,
  ModifyLoyaltyCustomerHistorical,
  ViewDashboard,
  ViewTaxes,
  ModifyTaxes,
  CreateTaxes,
  DeleteTaxes,
  ViewTags,
  CreateTags,
  ModifyTags,
  ViewChannelLogs,
  ResendReservationToChannel,
  UpdatePropertyChannelManagers,
  ViewGoogleFeed,
  ViewQueryExecutor,
  ViewChainConfigurer,
  ModifyAccessToProperty,
  ViewPropertyConfiguration,
  ModifyPropertyConfiguration,
  ViewIntegrationParameters,
  ModifyIntegrationParameters,
  ViewAriSnapshot,
  ViewCalendarRegen,
  CreateUserBatch,
  EditUserBatch,
  ShowEmailBlacklist,
  GenerateBillingReport,
  ViewCustomWeb,
  ModifyCustomWeb,
  ExportMaskedData,
  SendUnmaskedData,
  DownloadCustomersExcel,
  ViewEngineMultiConfig,
  CreateEngineMultiConfig,
  ModifyEngineMultiConfig,
  DeleteEngineMultiConfig,
  ViewLoyaltyPreferences,
  CreateLoyaltyPreferences,
  ModifyLoyaltyPreferences,
  DeleteLoyaltyPreferences,
  ViewLoyaltyBrandManager,
  ModifyLoyaltyBrandManager,
  ViewSellingConfiguration,
  CreateSellingConfiguration,
  ModifySellingConfiguration,
  DeleteSellingConfiguration,
  ViewUpgradeManager,
  CreateUpgradeConfiguration,
  ModifyUpgradeConfiguration,
  DeleteUpgradeConfiguration,
  UserPropertiesManager,
  ViewStoreOrders,
  ViewStoreProducts,
  CreateStoreProducts,
  ModifyStoreProducts,
  DeleteStoreProducts,
  ViewFunctionalityReport,
  ViewOrchestratorGlobalActions,
  CreateOrchestratorGlobalActions,
  ModifyOrchestratorGlobalActions,
  DeleteOrchestratorGlobalActions,
  ViewOrchestratorSegments,
  CreateOrchestratorSegments,
  ModifyOrchestratorSegments,
  DeleteOrchestratorSegments,
  ViewOrchestratorScenarios,
  CreateOrchestratorScenarios,
  ModifyOrchestratorScenarios,
  DeleteOrchestratorScenarios,
  ViewOrchestratorExperiments,
  CreateOrchestratorExperiments,
  ModifyOrchestratorExperiments,
  DeleteOrchestratorExperiments,
  ViewInsurances,
  CreateInsurances,
  ModifyInsurances,
  DeleteInsurances,
  ViewCampingMap,
  ModifyCampingMap,
  ViewCampingMapping,
  ModifyCampingMapping,
  ViewEngineFilters,
  CreateEngineFilters,
  ModifyEngineFilters,
  DeleteEngineFilters,
};
